// extracted by mini-css-extract-plugin
export var measureBox = "_4o-0";